import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { civilConstruction, constructionBanner, mechanicalConstruction } from 'images/expertise';
import DetailPage from 'containers/expertise/DetailPage';

const Construction: NextPage = () => {
  return (
    <>
      <Header
        title="Construction"
        description="We provide the leading-solutions for Construction industry. Utilities One's team effectively manages all facets of the telecom construction and installation process from initial planning to final system turn-up, as well as in-house structural modification crews. Our proven project management processes deliver results that meet or exceed customer expectations for quality and cost effectiveness, and make certain that all critical project deadlines are met. The Utilities One professional can handle the most complex installations, and our complete turnkey services streamline the project and keep it on track."
        image={constructionBanner}
      />
      <DetailPage
        listBlocks={[
          {
            id: 'civilConstruction',
            bgImage: civilConstruction,
            title: 'Civil Construction',
            hasListItems: true,
            description:
              'We perform heavy construction works by applying our professional capabilities, delivering innovative solutions and complex infrastructural services.',
            listItems: [
              { text: 'Heavy Construction' },
              { text: 'Roadway Restoration & Construction' },
              { text: 'Underground Utility Construction' },
              { text: 'Design & Build Services' },
            ],
          },
          {
            bgImage: mechanicalConstruction,
            id: 'mechanicalConstruction',
            title: 'Mechanical Construction',
            hasListItems: true,
            description:
              'We combine the knowledge of our design and construction teams to complete any mechanical construction project through quality design, installation, start-up and commissioning solutions.',
            listItems: [
              { text: 'Devices & Vessel Positioning' },
              { text: 'Piping' },
              { text: 'Millwright ' },
              { text: 'Metering' },
            ],
          },
        ]}
      />
    </>
  );
};

export default Construction;
